import { getProjectQuarterChangesFromLastQuarter } from "../Services/api"
import { exportToExcel } from "./excelUtils"

interface ProjectQuarterData {
  project_id: string | number
  project: string
  serial: string
  year: number
  quarter: number
  company: string
  stage: string
  status: string
  section_name: string
  subsection_name: string
  original_start_date: string
  updated_start_date: string
  updated_end_date: string
  previous_updated_start_date: string
  previous_updated_end_date: string
  end_date_change_months: number
  start_date_change_months: number
  current_quarter: string
  previous_quarter: string
  previous_status: string
  original_end_date: string
}

export const downloadQuarterlyReportExcel = async (projectId: string | number) => {
  try {
    const data: ProjectQuarterData[] = await getProjectQuarterChangesFromLastQuarter(projectId);

    if (!data || data.length === 0) {
      alert("לא נמצא מידע להשוואת רבעונים עבור פרויקט זה.");
      return;
    }

    const enrichedData = data.map(item => ({ ...item }));

    const currentQuarter = data[0].current_quarter;
    const previousQuarter = data[0].previous_quarter;

    exportToExcel(enrichedData, {
      fileName: 'CompareQuarters.xlsx',
      sheetName: 'דוחות',
      columnHeaders: {
        project: 'מיזם',
        company: 'גוף מדווח',
        serial: 'מספר סידורי',
        stage: 'שלב',
        section_name: 'מקטע',
        subsection_name: 'תת מקטע',
        original_start_date: 'תאריך התחלה מקורי',
        original_end_date: 'תאריך סיום מקורי',
        previous_status: `${previousQuarter} סטטוס`,
        previous_updated_start_date: `${previousQuarter}  תאריך התחלה`,
        previous_updated_end_date: `${previousQuarter}  תאריך סיום `,
        status: `${currentQuarter} סטטוס`,
        updated_start_date: `${currentQuarter}  תאריך התחלה`,
        updated_end_date: `${currentQuarter}  תאריך סיום `,
        start_date_change_months: 'משך עיכוב (חודשים) בהתחלה',
        end_date_change_months: 'משך עיכוב (חודשים) בסיום',
      },
    });
  } catch (error) {
    console.error("שגיאה בהורדת דוח אקסל:", error);
    alert("אירעה שגיאה בעת הורדת הדוח.");
  }
};
